import React, { useState } from 'react';

import { ModalComponent, UiComponent, UserGroupComponent } from 'components';
import { IUserGroupCandidate } from 'types';

interface Props {
  selected: IUserGroupCandidate[];
  onSelect: (selected: IUserGroupCandidate[]) => void;
  onClose: () => void;
}

/** 발송 대상 회원 선택 모달. 완료를 눌러야 폼에 반영된다. */
function UserSelect({ selected, onSelect, onClose }: Props) {
  const [draft, setDraft] = useState(selected);

  return (
    <ModalComponent.Portal>
      <ModalComponent.Background>
        <ModalComponent.Modal
          title="회원 선택"
          handleClose={onClose}
          footer={<></>}
        >
          <div css={{ width: '1000px', maxWidth: '80vw' }}>
            <UserGroupComponent.Picker
              selected={draft}
              onChange={setDraft}
              sources={['USER', 'GROUP', 'ENROLL']}
            />
            <div
              css={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '16px',
              }}
            >
              <p css={{ fontSize: '13px', color: '#8a8d94' }}>
                총 {draft.length.toLocaleString('ko')}명 선택
              </p>
              <div css={{ display: 'flex', gap: '0 8px' }}>
                <UiComponent.Button
                  variant="border"
                  color="primary"
                  onClick={onClose}
                >
                  취소
                </UiComponent.Button>
                <UiComponent.Button
                  variant="contained"
                  color="primary"
                  onClick={() => onSelect(draft)}
                >
                  선택 완료
                </UiComponent.Button>
              </div>
            </div>
          </div>
        </ModalComponent.Modal>
      </ModalComponent.Background>
    </ModalComponent.Portal>
  );
}

export default UserSelect;
